import { render, staticRenderFns } from "./MetaCenter.vue?vue&type=template&id=4cdee6b0&scoped=true"
import script from "./MetaCenter.vue?vue&type=script&lang=js"
export * from "./MetaCenter.vue?vue&type=script&lang=js"
import style0 from "./MetaCenter.vue?vue&type=style&index=0&id=4cdee6b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdee6b0",
  null
  
)

export default component.exports